// console.log(
//   "API URL : ",
//   process.env.REACT_APP_API_URL,
//   " NODE ENV : ",
//   process.env.NODE_ENV,
//   " Process.env : ",
//   JSON.stringify(process.env),
// );

const apisUrl = {
  baseUrl: process.env.REACT_APP_API_URL,
  requestAccessUrl: '/request-access',
};

export default apisUrl;
